module.exports = __webpack_public_path__ + "static/media/S1-21-Brox-cod41.fc227270.png";